<!-- 通话趋势 -->
<template>
<div id="callTrend" class="border-div"></div>
</template>

<script>
export default {
    name: "callTrend",
    props: {
        pageCode: String
    },
    data() {
        return {
            // 通话趋势
            callinCount_line: ["0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0",
                "0", "0", "0", "0", "0", "0"
            ],
            calloutAnswer_line: ["0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0",
                "0", "0", "0", "0", "0", "0"
            ],
            calloutCount_line: ["0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0",
                "0", "0", "0", "0", "0", "0"
            ],
            callinAnswer_line: ["0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0",
                "0", "0", "0", "0", "0", "0"
            ],
            timeFlag: '',
            lineChart: null,
            //isFullFlag:false,
        }
    },
    created() {

    },
    mounted() {
        this.lineChart = this.$echarts.init(document.getElementById("callTrend"));
        this.getCallTrend();
        this.timeFlag = setInterval(this.getCallTrend, 5000);
    },
    methods: {
        // 通话趋势
        getCallTrend() {
            let that = this;
            let param = {
                journalType: null,
                menuId: null
            };
            this.$http.post("bigScreen/toCallTrendsIndex.json", param).then(function (res) {
                let result = res.data.flag;
                if (result != "666") {
                    that.$Modal.info({
                        title: '提示',
                        content: res.data.msg
                    });
                    return false;
                }

                that.callinCount_line = res.data.obj.callinCount;
                that.calloutAnswer_line = res.data.obj.calloutAnswer;
                that.calloutCount_line = res.data.obj.calloutCount;
                that.callinAnswer_line = res.data.obj.callinAnswer;

                that.handleTopLeftEchart(); // 左上折线图
            })
        },

        // 处理左上折线图
        handleTopLeftEchart() {
            let that = this;
            // 1.实例化对象
            // that.lineChart = this.$echarts.init(document.getElementById("callTrend"));
            // 2.把配置项给实例对象
            that.lineChart.setOption({
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    data: ["呼出量", "呼入量", "呼出接通量", "呼入接通量"],
                    padding: [20, 0, 0, 20],
                    textStyle: {
                        fontSize: 16,
                        padding: 8,
                        color: function (params) {},
                    },
                },
                grid: {
                    left: "3%",
                    right: "4%",
                    bottom: "2%",
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        // saveAsImage: {}
                    }
                },
                xAxis: {
                    type: "category",
                    boundaryGap: false,
                    data: [
                        "00:00",
                        "01:00",
                        "02:00",
                        "03:00",
                        "04:00",
                        "05:00",
                        "06:00",
                        "07:00",
                        "08:00",
                        "09:00",
                        "10:00",
                        "11:00",
                        "12:00",
                        "13:00",
                        "14:00",
                        "15:00",
                        "16:00",
                        "17:00",
                        "18:00",
                        "19:00",
                        "20:00",
                        "21:00",
                        "22:00",
                        "23:00"
                    ],
                    axisTick: {
                        // show: false // 去除刻度线
                    },
                    axisLabel: {
                        color: "#4c9bfd" // 文本颜色
                    },
                    axisLine: {
                        show: false // 去除轴线
                    }
                },

                yAxis: {
                    type: "value",
                    axisTick: {
                        show: false // 去除刻度线
                    },
                    axisLabel: {
                        color: "#4c9bfd" // 文本颜色
                    },
                    axisLine: {
                        // show: false // 去除轴线
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: "#4c9bfd",
                            type: 'dotted',
                            width: 1.5,
                        }
                    }
                },
                series: [{
                        name: "呼出量",
                        type: "line",
                        smooth: true,
                        // 填充颜色设置
                        areaStyle: {
                            color: new this.$echarts.graphic.LinearGradient(
                                0, 0, 0, 1,
                                [{
                                        offset: 0,
                                        color: "rgba(205,153,253, 0.4)" // 渐变色的起始颜色
                                    },
                                    {
                                        offset: 0.8,
                                        color: "rgba(205,153,253, 0.1)" // 渐变线的结束颜色
                                    }
                                ],

                            ),

                        },
                        // 设置拐点
                        symbol: "circle",
                        // 拐点大小
                        symbolSize: 6,
                        // 开始不显示拐点， 鼠标经过显示
                        showSymbol: false,
                        itemStyle: {
                            normal: {
                                color: "rgba(205,153,253,1)", //图例的颜色
                                lineStyle: {
                                    color: 'rgba(205,153,253,1)',
                                    width: 1.5
                                },
                            },
                        },
                        data: this.calloutCount_line
                    },
                    {
                        name: "呼入量",
                        type: "line",
                        smooth: true,
                        // 填充颜色设置
                        areaStyle: {
                            color: new this.$echarts.graphic.LinearGradient(
                                0, 0, 0, 1,
                                [{
                                        offset: 0,
                                        color: "rgba(146,200,249, 0.4)" // 渐变色的起始颜色
                                    },
                                    {
                                        offset: 0.8,
                                        color: "rgba(146,200,249, 0.1)" // 渐变线的结束颜色
                                    }
                                ],

                            ),
                        },
                        // 设置拐点
                        symbol: "circle",
                        // 拐点大小
                        symbolSize: 6,
                        // 开始不显示拐点， 鼠标经过显示
                        showSymbol: false,
                        itemStyle: {
                            normal: {
                                color: 'rgba(146,200,249,1)', //图例的颜色
                                lineStyle: {
                                    color: 'rgba(146,200,249,1)',
                                    width: 1.5
                                },
                            },
                        },
                        data: this.callinCount_line
                    },
                    {
                        name: "呼出接通量",
                        type: "line",
                        smooth: true,
                        // 填充颜色设置
                        areaStyle: {
                            color: new this.$echarts.graphic.LinearGradient(
                                0, 0, 0, 1,
                                [{
                                        offset: 0,
                                        color: "rgba(225,173,90, 0.4)" // 渐变色的起始颜色
                                    },
                                    {
                                        offset: 0.8,
                                        color: "rgba(225,173,90, 0.1)" // 渐变线的结束颜色
                                    }
                                ],

                            ),
                        },
                        // 设置拐点
                        symbol: "circle",
                        // 拐点大小
                        symbolSize: 6,
                        // 开始不显示拐点， 鼠标经过显示
                        showSymbol: false,
                        itemStyle: {
                            normal: {
                                color: 'rgba(225,173,90,1)', //图例的颜色
                                lineStyle: {
                                    color: 'rgba(225,173,90,1)',
                                    width: 1.5
                                },
                            },
                        },
                        data: this.calloutAnswer_line
                    },
                    {
                        name: "呼入接通量",
                        type: "line",
                        smooth: true,
                        // 填充颜色设置
                        areaStyle: {
                            color: new this.$echarts.graphic.LinearGradient(
                                0, 0, 0, 1,
                                [{
                                        offset: 0,
                                        color: "rgba(52,171,255, 0.4)" // 渐变色的起始颜色
                                    },
                                    {
                                        offset: 0.8,
                                        color: "rgba(52,171,255, 0.1)" // 渐变线的结束颜色
                                    }
                                ],
                            ),
                        },
                        // 设置拐点
                        symbol: "circle",
                        // 拐点大小
                        symbolSize: 6,
                        // 开始不显示拐点， 鼠标经过显示
                        showSymbol: false,
                        itemStyle: {
                            normal: {
                                color: 'rgba(52,171,255,1)', //图例的颜色
                                lineStyle: {
                                    color: 'rgba(52,171,255,1)',
                                    width: 1.5
                                },
                            },
                        },
                        data: this.callinAnswer_line
                    }
                ]
            });
            // 让图表跟随屏幕自动的去适应
            //window.addEventListener("resize", that.resizeFun);
        },

        // resizeFun(){
        //   let that = this;
        //   that.lineChart.resize();
        // }

    },
    watch: {
        pageCode: function () {
            if (this.pageCode == '8_5-1') {
                let that = this;
                // if (that.lineChart) {
                that.lineChart.resize();
                // } 
            }
        }
    },
    beforeDestroy() {
        if (this.timeFlag) {
            clearInterval(this.timeFlag);
        }
        window.removeEventListener("resize", this.resizeFun);
        this.resizeFun = null;
        this.lineChart = null;
        this.handleTopLeftEchart = null;
        this.getCallTrend = null;
        this.$echarts = null;
    },
    destroyed() {

    },

}
</script>

<style lang="less" scoped>
@import "../../assets/css/daping.less";
</style>



// WEBPACK FOOTER //
// src/components/bigScreen/callTrend.vue